import { render, staticRenderFns } from "./DetailProduct.vue?vue&type=template&id=6d6ebb4a&"
import script from "./DetailProduct.vue?vue&type=script&lang=js&"
export * from "./DetailProduct.vue?vue&type=script&lang=js&"
import style0 from "./DetailProduct.vue?vue&type=style&index=0&id=6d6ebb4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports